__turbopack_context__.v({
  "cartCheckoutDisclosures": "cartCheckoutDisclosures-module-scss-module__Wd4GSq__cartCheckoutDisclosures",
});
